import React from 'react';
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import consultIcon from '../../assets/images/consult-icon.svg';
import { convertUTCtoLocalFullDate } from '../../helper';
import { showPrescriptionURL } from '../../helper/mobile';

const CardList = ({icon, text}) => {
  const iconImg = require('../../assets/images/'+icon);
  return(
    <div className="d-flex align-items-start align-items-center consult-card-detail">
      <img className="me-3" src={iconImg} alt={text} />
      <div className='w-100 overflow-hidden'>
          <p className='mb-0'>{text}</p>
      </div>
    </div>
  );
}

const BookCard = ({booking}) => {

  const getRefundStatus = (rs) => {
    let refundStatus = '';
    if(rs === 'refund_successful')
      refundStatus = 'Refund Successful';
    else if(rs === 'refund_initiated')
      refundStatus = 'Refund Initiated';
    else if(rs === 'refunded_failed')
      refundStatus = 'Refund Failed';
    else if(rs === 'payment_captured')
      refundStatus = 'Paid Successfully';
    else if(rs === 'payment_successful')
      refundStatus = 'Paid Successfully';
    else if(rs === 'payment_initiated')
      refundStatus = 'Payment Initiated';
    else if(rs === 'payment_failed')
      refundStatus = 'Payment Failed';
    else
      refundStatus = '-';

    return refundStatus;
  }

  const urlClicked = (url) => {
    showPrescriptionURL(url)
  }
  return(
    <>
      { booking.map(obj => {
        let cardRightIcon = 'completed.svg';
        if(obj.consultationStatus === 'cancelled' || obj.consultationStatus === 'payment_failed')
          cardRightIcon = 'cancelled.svg'
        return(
          <Card className='consult-card' key={obj?.consultationId}>
            <CardHeader>
              <div className="d-flex align-items-start align-items-center">
                <img className="me-2" src={consultIcon} alt='consult icon' />
                <div className='w-100 overflow-hidden'>
                    <img src={require('../../assets/images/'+cardRightIcon)} className='float-end mt-2' alt='right arrow' />
                    <h5 className='mb-0'>General Consult</h5>
                    <p className='mb-0 consultation-status text-capitalize'>{obj.consultationStatus === 'payment_failed' ? 'Cancelled' : obj.consultationStatus}</p>
                </div>
              </div>
            </CardHeader>
            <CardBody>
              <CardList icon='price.svg' text={getRefundStatus(obj.paymentStatus)} />
              { obj.consultationStatus === 'completed' &&  <CardList icon='time.svg' text={convertUTCtoLocalFullDate(obj.scheduledTime)} /> }
              { obj.consultationStatus === 'completed' && <CardList icon='phone.svg' text={'Consult with Dr. '+obj.doctorName} /> }
              <CardList icon='user.svg' text={`Consult for ${obj.userInfo.firstName}`} />
            </CardBody>
            { obj.prescriptionUrl && 
              <CardFooter>
                {/* <Button color="link" className='btn-prescription' onClick={() => urlClicked(obj.prescriptionUrl)}>View Prescription</Button> */}
                <div className='btn-prescription' onClick={() => urlClicked(obj.prescriptionUrl)}>View Prescription</div>
                {/* <button className='btn-prescription' target='_blank' rel="noopener noreferrer" ></button> */}
              </CardFooter>
            }
          </Card>
        )
      }) }
    </>
  );
}

export default BookCard;